
export default () => {
  return {
    showTableau: false,
    isInitialized: false,
    isUpdating: false,
    totalSheets: 1,
    sheetsInitialized: 0,
    parameters: {},
    vizFilters: {},
  }
}
